import { Box } from '@mui/material';
import { withTheme } from '@mui/styles';
import styled from 'styled-components';

export const Style = withTheme(styled(Box)`
  background-color: ${(props: any) => props.theme.palette.info.light};
  ${(props: any) =>
    props.backgroundImage
      ? `
    background-image: url(${props.backgroundImage});
    background-position: center;
    background-repeat: no-repeat, no-repeat, no-repeat;
    background-size: cover;

    ${props.theme.breakpoints.down('lg')} {
      background-size: initial;
    }
  `
      : ''}

  height: ${(props: any) => props.contentHeight};
  position: relative;
`);

export const HeaderContainer = withTheme(styled(Box)`
  max-width: 1180px;

  ${(props: any) =>
    props.isSupportLargeScreen &&
    `
    @media (max-width: 1999px) and (min-width: 1701px) {
      max-width: 1460px;
    }
    @media (min-width: 2000px) {
      max-width: 1750px;
    }
  `}

  margin: 0 auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 1rem;
  & .MuiBreadcrumbs-li * {
    font-size: 18px;
  }
  .title {
    text-align: center;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    font-size: 24px;
    line-height: 24px;
    color: rgba(255, 255, 255, 0.74);
  }
  .description {
    text-align: center;
    margin-top: 8px;
    line-height: 42px;
    font-size: 36px;
    font-weight: bold;
    color: #fff;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  ${(props: any) => props.theme.breakpoints.down('lg')} {
    .title {
      -webkit-line-clamp: 2;
    }
  }

  ${(props: any) => props.theme.breakpoints.down('sm')} {
    .title {
      font-size: 18px;
      line-height: 22px;
    }
    .description {
      font-size: 24px;
      line-height: 24px;
    }
  }

  .breadcrumb-link {
    color: #fff;
    font-family: 'Heavent';
    font-size: 18px;
    line-height: 22px;
    padding: 0;
    font-weight: bold;
    border-radius: 4px;
  }
`);
